import * as React from "react"
const SvgPieChart = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 11.571h6.95q-.375-2.75-2.287-4.662Q15.749 4.996 13 4.62zm-2 8.95v-15.9q-3.025.375-5.013 2.638T4 12.57q0 3.051 1.987 5.313Q7.975 20.146 11 20.52Zm2 0q2.75-.35 4.675-2.275t2.275-4.675H13zm-1 2.05a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2.57q2.076 0 3.887.788a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175A9.65 9.65 0 0 1 22 12.57a9.7 9.7 0 0 1-.788 3.875 10.3 10.3 0 0 1-2.137 3.188 10 10 0 0 1-3.175 2.15 9.7 9.7 0 0 1-3.9.787Z" />
  </svg>
)
export default SvgPieChart
